export default {
  "menu.login": "登录",
  "menu.dashboard": "首页",
  "menu.aiRecommendation": "AI 建议历史",
  "menu.analytics": "智能分析",
  "menu.stock": "库存查看",
  "menu.transaction": "出入库",
  "menu.inventoryCheck": "盘点",
  "menu.product": "产品管理",
  "menu.contact": "往来单位",
  "menu.settings": "设置",
  "menu.pricing": "定价",
  "menu.account.logout": "退出登录",

  // hideInMenu（侧栏不显示，但需要面包屑/标题文案）
  "menu.aiLineSetup": "LINE 绑定",
  "menu.aiMonthlyReport": "月度报告",
};
